import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { isProd, setFavicon } from "../../utils/AppUtils";
import { getLoginLogo, getLoginLogoClear } from "../../redux/home/actions";
import CONFIG from "../../utils/config";
import API_LIST from "../../utils/apiList";
import _ from "lodash";

const MenuChangePassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loginLogo = useSelector((state) => state.home.loginLogo);
  const [showPasswordChange, setShowPasswordChange] = useState(false);

  useEffect(() => {
    const domainArray = window.location.host.split(".");
    let subDomain = "";

    if (!domainArray[0].includes("localhost")) {
      //domainArray[0] !== CONFIG.SUB_DOMAIN_NAME &&
      subDomain = isProd()
        ? domainArray[0] + "." + domainArray[1]
        : domainArray[0];
      dispatch(
        getLoginLogo({
          URL: `${CONFIG.API_URL_BROKER_ADMIN}${API_LIST.BROKER_API.LOGIN_LOGO_URL}`,
          payload: {
            company_ref: subDomain,
            // email: localStorage.getItem('redirect_email')
          },
          isJSON: true,
          method: "post",
        })
      );
    }
  }, []);

  useEffect(() => {
    if (!_.isEmpty(loginLogo)) {
      if (
        loginLogo.status === "success" &&
        !_.isEmpty(loginLogo.payload?.data)
      ) {
        let data = loginLogo.payload.data.sso_response;
        if (data?.is_sso_enabled === "1") {
          setShowPasswordChange(false);
        } else {
          setShowPasswordChange(true);
        }

        setTimeout(() => {
          dispatch(getLoginLogoClear());
        }, 2000);
      } else {
        setTimeout(() => {
          dispatch(getLoginLogoClear());
        }, 2000);
      }
    }
  }, [loginLogo]);
  return (
    <>
      {showPasswordChange ? (
        <li>
          <button
            className="dropdown-item"
            type="button"
            onClick={() => {
              navigate("/change-password");
            }}
          >
            Change Password
          </button>
        </li>
      ) : (
        ""
      )}
    </>
  );
};
export default MenuChangePassword;
